import { cn } from '@lib/cn'
import { HTMLAttributes, forwardRef } from 'react'

type As = 'div' | 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
// These are coming straight from the Rolex docs, don't blame me
type Variant = 'headline70' | 'headline50' | 'headline36' | 'headline30' | 'headline26'

export type HeadingProps = HTMLAttributes<HTMLElement> & {
  variant: Variant
  as?: As
}

export const Heading = forwardRef<HTMLElement, HeadingProps>(
  ({ variant, children, className = '', as: Component = 'div', ...rest }, ref) => {
    return (
      <Component
        ref={ref as any}
        className={cn(
          'text-with-links font-rolex font-bold',
          variant === 'headline70' && 'text-[36px] leading-[1.1] lg:text-[70px]',
          variant === 'headline50' && 'text-[30px] leading-[1.2] lg:text-[50px]',
          variant === 'headline36' && 'text-[24px] leading-[1.2] lg:text-[36px]',
          variant === 'headline30' && 'text-[22px] leading-[1.2] lg:text-[30px]',
          variant === 'headline26' && 'text-[22px] leading-[1.2] lg:text-[26px]',
          className,
        )}
        {...rest}
      >
        {children}
      </Component>
    )
  },
)

Heading.displayName = 'Heading'
